import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import { UtilitiesHelper } from '../../../core/helpers/utilities.helper';
import { SfgeHelper } from '../../../core/helpers/sfge.helper';
import { SfgeService } from '../../../core/services/sfge.service';

import { Router } from '@angular/router';

@Component({
  selector: 'app-patientsmart-header',
  standalone: true,

  imports: [
    CommonModule
  ],

  templateUrl:
    './patientsmart-header.component.html',

  styleUrls: [
    './patientsmart-header.component.scss'
  ]
})
export class PatientsmartHeaderComponent
  implements OnChanges {

  @Input()
  patient: any = null;

  @Input()
  accessiCount = 0;

  utilitiesHelper = UtilitiesHelper;
  sfgeHelper = SfgeHelper;

  lastSfge: any = null;

  constructor(
    private router: Router,
    private sfgeService: SfgeService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['patient']) {

      this.loadLastSfge();
    }
  }

  loadLastSfge(): void {

    this.lastSfge = null;

    const idPaziente =
      this.patient?.idPaziente;

    if (!idPaziente) {

      return;
    }

    this.sfgeService
      .getByPatient(idPaziente)
      .subscribe({

        next: (results: any[]) => {

          if (results && results.length > 0) {

            const sorted = [...results].sort((a, b) => {

              const dateA = new Date(a.dataAccesso || a.dataCompilazione || 0).getTime();
              const dateB = new Date(b.dataAccesso || b.dataCompilazione || 0).getTime();

              return dateB - dateA;
            });

            this.lastSfge = sorted[0];
          }
        },

        error: () => {

          this.lastSfge = null;
        }
      });
  }

  goToPatient(): void {

    if (!this.patient?.idPaziente) {

      return;
    }

    this.router.navigate([
      '/patients',
      this.patient.idPaziente
    ]);
  }
}